import { useEffect, useState } from "react";
import {
    Container,
    Description,
    GlobalStyle,
    HeaderDash,
    ListView,
    TopMenu,
    Wrapper,
} from "../../common";
import { Load } from "../../common/load/load";
import { SessionListItem } from "./application/domain/session-list-item";
import { ListSessionsController } from "./infra/controller/list-sessions.controller";
import { SessionListItemCard } from "./session-list-item";

export const ListSessionsUi = () => {
    const [sessions, setSessions] = useState<SessionListItem[]>([]);
    const [load, setLoad] = useState(false);

    useEffect(() => {
        void ListSessionsController.loadSessions({ setLoad, setSessions });
    }, []);

    return (
        <>
            <GlobalStyle />
            {load && <Load />}
            <Container>
                <TopMenu />
                <Wrapper>
                    <HeaderDash
                        title="Sessões"
                        description="Todas as sessões de treino criadas"
                    />
                    {!sessions?.length && (
                        <Description align="center">Nenhuma sessão encontrada</Description>
                    )}

                    <ListView top="30px">
                        {sessions.map((session) => (
                            <SessionListItemCard key={session.id} session={session} />
                        ))}
                    </ListView>
                </Wrapper>
            </Container>
        </>
    );
};
